import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useParams } from 'react-router-dom';
import parse from 'html-react-parser';
import { postKycReport } from '../src/investorsApis';

const KYCReport = () => {
  const { userId } = useParams<{ userId:string }>();
  const [html, setHtml] = useState<string>();

  const { mutate } = useMutation(['postKycReport', userId], postKycReport, {
    onSuccess: (response) => {
      setHtml(response.data);
    },
  });

  useEffect(() => {
    const formData = new FormData();
    formData.append('id', userId || '');
    mutate(formData);
  }, []);

  return (
    <div>{parse(html || '')}</div>
  );
};

export default KYCReport;
